import type { ReactNode } from "react";
import { MarkdownContent } from "@/components/shared/Markdown/MarkdownContent";
import styles from "./ContentPageHeader.module.scss";

interface IContentPageHeaderProps {
  title: string;
  name: string;
  summary?: string;
  mediaBaseUrl?: string;
  isEngagementDetailsPage?: boolean;
}

export function ContentPageHeader({
  title,
  name,
  summary,
  mediaBaseUrl,
  isEngagementDetailsPage = false,
}: IContentPageHeaderProps): ReactNode {
  const headerClassName = [styles.header, !isEngagementDetailsPage ? styles.onlyChildParagraphSpacing : undefined]
    .filter(Boolean)
    .join(" ");

  return (
    <header className={headerClassName}>
      <p className="font-size-h1 font-weight-semibold header-title">{title ?? name}</p>
      {summary && (
        <div className={styles.summary}>
          <MarkdownContent content={summary} mediaBaseUrl={mediaBaseUrl} />
        </div>
      )}
    </header>
  );
}
